module.exports = __webpack_public_path__ + "img/20014.afe21d84.png";